import { Component, OnInit, Renderer, OnDestroy } from '@angular/core';
import { ContactosService } from '../../services/contactos.service';
import { ActivatedRoute } from '@angular/router'
import { Contacto } from '../../interfaces/contactos.interface';

@Component({
  selector: 'app-exitoso',
  templateUrl: './exitoso.component.html',
  styles: []
})
export class ExitosoComponent implements OnInit, OnDestroy {
  contacto: Contacto = {
    fecha: '',
    nombre: '',
    email: '',
    mensaje: ''
  }
  // id: string;
  constructor(  private _cs: ContactosService,
                private actRoute: ActivatedRoute,
                private renderer: Renderer ) {
      this.renderer.setElementClass(document.body, 'paginas-internas', true);
      this.actRoute.params.subscribe( parametros => {
        this._cs.getMensaje(parametros['id']).subscribe (data => {
          this.contacto = data;
        });
      });
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.renderer.setElementClass(document.body, 'paginas-internas', false);
  }
}



// WEBPACK FOOTER //
// /Users/diego/Documents/SirisWebSite/WebSite/src/app/components/contacto/exitoso.component.ts